<script lang="ts">
    import type {Rec} from 'typings/portaro.be.types';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {createProjectLogbookPairingContext} from './project-logbook-pairing-context';
    import {getInjector} from 'core/svelte-context/context';
    import {ProjectLogbookPairingService} from './project-logbook-pairing.service';
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {popInAnim, popOutAnim} from 'shared/animations/pop-animations';
    import {SUTOR_LOGBOOK_PAIRING_PAGE} from 'src/features/erp-sutor/sutor-constants';
    import LogbookPairingSplit from './LogbookPairingSplit.svelte';
    import LogbookPairingRowOptionsCell from './LogbookPairingRowOptionsCell.svelte';
    import KpRecordGrid from 'src/features/record-grid/KpRecordGrid.svelte';
    import Flex from 'shared/layouts/flex/Flex.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let record: Rec;

    const service = getInjector().getByClass(ProjectLogbookPairingService);
    const context = createProjectLogbookPairingContext(record, service);

    let openedLogbook: RecordRow | null = null;
    const openedLogbookUnsubscribe = context.openedLogbook$.subscribe((currentOpenedLogbook) => openedLogbook = currentOpenedLogbook);

    onDestroy(() => {
        openedLogbookUnsubscribe();
    });

    const handleBatchExportClick = async () => {
        await context.service.batchExportLogbooksToProjectFiles(context.projectRecord);
    };
</script>

<Flex class="sutor-logbook-pairing" direction="column" fillAvailableSpace>
    <div class="overlay-container">
        {#if !exists(openedLogbook)}
            <div class="grid-container record-grid-tab-page"
                 in:popInAnim={{key: 'grid'}}
                 out:popOutAnim={{key: 'grid'}}>

                <div class="action-buttons-container">
                    <KpButton on:click={handleBatchExportClick}>
                        <IconedContent icon="file-export">
                            Hromadný export do složky zakázky
                        </IconedContent>
                    </KpButton>
                </div>

                <KpRecordGrid rowOptionsCellComponent={LogbookPairingRowOptionsCell}
                              fondOrFondId={SUTOR_LOGBOOK_PAIRING_PAGE.logbooksFond}
                              referenceRecordId={context.projectRecord.id}
                              referenceFieldTypeId={SUTOR_LOGBOOK_PAIRING_PAGE.logbookReferenceField}/>
            </div>
        {:else}
            <div class="reports-container"
                 in:popInAnim={{key: 'logbook-reports'}}
                 out:popOutAnim={{key: 'logbook-reports'}}>

                <LogbookPairingSplit {openedLogbook}/>
            </div>
        {/if}
    </div>
</Flex>

<style lang="less">
    @import (reference) "styles/portaro-erp.less";
    @import (reference) "styles/portaro.variables.less";

    .overlay-container {
        .flex-grow();
        position: relative;

        .grid-container,
        .reports-container {
            .flex-grow();
            align-items: start;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    .action-buttons-container {
        padding-inline: @spacing-xxl;
        padding-top: @spacing-ml;
    }
</style>